
import React, { useEffect } from 'react';

import { fluidRange, styled } from '~/styles';
import backgroundImg from '~/assets/images/gallery-background.jpg';
import {
  PageContainer, 
  PageHeadline, 
  TopContainer
} from '~/components/layout/PageBasics';
import { 
  ResourcesContainer, 
  ResourcesContainerOuter 
} from '~/components/layout/resources/ResourcesContainer';
import ResourcesList from '~/components/layout/resources/ResourcesList';
import config from '~/config';

const StyledTopContainer = styled(TopContainer)`
  justify-content: flex-start;
  ${fluidRange('paddingTop', '20px', '50px')}
  flex: 1 0 100px;
`


function ResourceGalleryPage() {
  useEffect(() => {
    document.title = config.title + ' | Gallery';
  }, []);

  return (
    <PageContainer bgImage={backgroundImg}>
      <StyledTopContainer>
        {/* <PageHeadline>Reso<b>u</b>rce Gallery</PageHeadline> */}
        <PageHeadline>Reso<b>u</b>rce Gallery</PageHeadline>
      </StyledTopContainer>

      <ResourcesContainerOuter>
        <ResourcesContainer>
          <ResourcesList />
        </ResourcesContainer>
      </ResourcesContainerOuter>
    </PageContainer>
  );
}

export default ResourceGalleryPage;



// WEBPACK FOOTER //
// ./src/pages/resources/resources-gallery.tsx